import { useMemo } from 'react';

import { useGetExtranetPendingChanges } from '~/hooks/apis/extranet/useExtranetPendingChanges';

import { ListExtranetPendingChangesParams } from '~/services/ExtranetService';

export default function useExtranetApprovalsData(appliedFilters: ListExtranetPendingChangesParams) {
  const { data, isLoading, error } = useGetExtranetPendingChanges(appliedFilters);
  const { data: pendingCountData } = useGetExtranetPendingChanges({ status: 'pending', limit: 0 });
  const { data: homesVillasPendingCountData } = useGetExtranetPendingChanges({
    status: 'pending',
    propertyCategory: 'Homes & Villas',
    limit: 0,
  });

  const rows = useMemo(() => data?.result ?? [], [data?.result]);
  const total = data?.total ?? 0;

  return {
    counts: {
      homesVillasPending: homesVillasPendingCountData?.total ?? 0,
      pending: pendingCountData?.total ?? 0,
    },
    error,
    isLoading,
    rows,
    total,
  };
}
